import { useContext } from "react";

import { Box, Grid, useTheme } from "@mui/material";

import { isProductElectronic } from "@aclymatepackages/products";

import NumberInput from "../../atoms/inputs/NumberInput";

import {
  SectionHeader,
  CategorySection,
  FlatMaterialsSection,
  ElectronicsSection,
  PackagingSection,
  RouteSection
} from "../product-bom-fields/ProductBomSections";

import { SurveyContext } from "../survey-shape/SurveyContext";

const ProductWeightSection = ({ value, setBomField }) => (
  <>
    <SectionHeader
      title="Product weight"
      description="Total weight of one finished unit, in grams."
    />
    <NumberInput
      label="Weight (grams)"
      value={value || ""}
      setValue={(next) => setBomField("productWeight", Number(next) || 0)}
    />
  </>
);

const BomSurveyForm = () => {
  const { palette } = useTheme();
  const context = useContext(SurveyContext);
  const { currentBomValues, setBomField, readOnly } = context || {};
  const values = currentBomValues || {};
  const isElectronic = isProductElectronic(values.category, values.subcategory);

  return (
    <Box
      style={{
        backgroundColor: palette.common.white,
        borderRadius: 8,
        border: `1px solid ${palette.backgroundGray.dark}`,
        padding: 24,
        ...(readOnly ? { pointerEvents: "none", opacity: 0.6 } : {})
      }}
      aria-disabled={readOnly ? true : undefined}
    >
      <Grid container direction="column" spacing={3}>
        <Grid item>
          <ProductWeightSection
            value={values.productWeight}
            setBomField={setBomField}
          />
        </Grid>
        <Grid item>
          <CategorySection
            category={values.category}
            subcategory={values.subcategory}
            onChangeCategory={() => {}}
            onChangeSubcategory={(next) => setBomField("subcategory", next)}
            categoryReadOnly
          />
        </Grid>
        <Grid item>
          <FlatMaterialsSection
            materials={values.components}
            onChange={(next) => setBomField("components", next)}
          />
        </Grid>
        {isElectronic && (
          <Grid item>
            <ElectronicsSection
              electronics={values.electronics}
              onChange={(next) => setBomField("electronics", next)}
            />
          </Grid>
        )}
        <Grid item>
          <PackagingSection
            packaging={values.packaging}
            packagingWeight={values.packagingWeight}
            onChange={(next) => setBomField("packaging", next)}
            onChangeWeight={(next) => setBomField("packagingWeight", next)}
          />
        </Grid>
        <Grid item>
          <RouteSection
            route={values.route}
            onChange={(next) => setBomField("route", next)}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default BomSurveyForm;
